import styled from "@emotion/styled";
import { Container, Card, Typography } from "@mui/material";

export const StyledContainer = styled(Container)({
  backgroundColor: "#F5F5F5",
  minHeight: "100vh",
  height: "100%",
});

export const StyledCard = styled(Card)({
  backgroundColor: "#31313175 !important",
  padding: "20px",
  position: "relative",
  top: "0.75rem",
  width: "100%",
  color: "white",
});

export const StyledCard2 = styled(Card)({
  backgroundColor: "#31313175 !important",
  padding: "20px",
  position: "relative",
  top: "0.3rem",
  width: "60%",
  color: "white",
  margin: "0 auto",
});

export const StyledTypographic = styled(Typography)({
  fontWeight: 700,
  textTransform: "uppercase",
});
